import * as Sentry from "@sentry/ember";
// If you update this code, also update back/app/controllers/concerns/semeia_sentry.rb
// to make sure back and front transactions stay in sync.
export function setSentryUser(user) {
  const scope = Sentry.getCurrentScope();
  scope.setUser(user);
}
export function initializeSentry(environment, opts) {
  const sentryConfiguration = {
    environment,
    normalizeDepth: 11,
    ...(opts || {})
  };
  const disabledEnvs = ["production", "preproduction"];
  if (!disabledEnvs.includes(environment)) {
    // Enable Sentry Replay, only on non-production environments.
    sentryConfiguration.integrations = [Sentry.replayIntegration()];
    sentryConfiguration.replaysSessionSampleRate = 0.1;
    sentryConfiguration.replaysOnErrorSampleRate = 1.0;
    sentryConfiguration.tracesSampleRate = 1.0;
  }
  Sentry.init(sentryConfiguration);
}
export function resetSentryUser() {
  const scope = Sentry.getCurrentScope();
  scope.setUser(null);
}

/**
 * Actually the metric's tag are not send to Sentry
 */
export function setSentrySpanAttributes(metrics) {
  const activeSpan = Sentry.getActiveSpan();
  metrics.forEach(metric => {
    activeSpan?.setAttribute(metric.name, metric.value);
  });
}

/**
 * Actually the metric's tag are not send to Sentry
 */
export function setSentryTags(metrics) {
  metrics.forEach(metric => {
    Sentry.setTag(metric.name, metric.value);
  });
}